export const bmsItems = [
  {
    id: 1,
    imageSrc: "transparent",
    title: "Core Module",
    type: "Lightbox",
    categories: ["core"],
    description: {
      heading: "Core Module",
      subheading: "The Foundation of Your Business",
      text: "The Core Module is the foundation of the Business Comanager platform. It provides the essential framework for managing your entire business ecosystem, including user management, permissions, system settings, and integration capabilities. With the Core Module, you can configure your business rules, policies, and strategies, while the AI assistant helps you manage tasks, monitor compliance, and track performance metrics.",
    },
  },
  {
    id: 2,
    imageSrc: "transparent",
    title: "Accounting Module",
    type: "External Page",
    categories: ["accounting"],
    description: {
      heading: "Accounting Module",
      subheading: "Financial Management Simplified",
      text: "The Accounting Module provides a comprehensive solution for managing your organization's financial operations. From journal entries and reconciliation to financial reporting and tax management, this module streamlines your accounting processes. With features like chart of accounts, balance sheets, income statements, and cash flow analysis, you'll have complete visibility into your financial health and can make informed decisions to drive your business forward.",
    },
  },
  {
    id: 3,
    imageSrc: "transparent",
    title: "Budget Module",
    type: "External Page",
    categories: ["budget"],
    description: {
      heading: "Budget Module",
      subheading: "Strategic Financial Planning",
      text: "Take control of your finances with our Budget Module. This powerful tool enables you to create, manage, and track budgets across your organization. Monitor income and expenses, analyze cash flow, and manage assets with ease. The forecasting capabilities help you plan for the future, while detailed reports provide insights into spending patterns and financial performance. With the Budget Module, you can make data-driven decisions to optimize your financial resources.",
    },
  },
  {
    id: 4,
    imageSrc: "transparent",
    title: "Human Resources",
    type: "External Page",
    categories: ["hr", "management"],
    description: {
      heading: "Human Resources Module",
      subheading: "Empowering Your Workforce",
      text: "The Human Resources Module helps you manage your most valuable asset - your people. From employee records and department structures to leave management and attendance tracking, this module streamlines HR operations. Handle compensation, benefits, and payroll with ease, while fostering employee development through performance management and training programs. The HR Module provides the tools you need to build and maintain a productive, engaged workforce.",
    },
  },
  {
    id: 5,
    imageSrc: "transparent",
    title: "Recruitment Module",
    type: "External Page",
    categories: ["hr"],
    description: {
      heading: "Recruitment Module",
      subheading: "Talent Acquisition Reimagined",
      text: "Transform your hiring process with our Recruitment Module. This comprehensive solution helps you manage job postings, track applications, and streamline candidate evaluations. The AI-powered matching system connects the right candidates with the right positions, while the customizable form builder allows you to create tailored application forms. With features for workforce intermediation and detailed analytics, you can optimize your recruitment strategy and find the best talent for your organization.",
    },
  },
  {
    id: 6,
    imageSrc: "transparent",
    title: "Production Module",
    type: "Lightbox",
    categories: ["production", "management"],
    description: {
      heading: "Production Module",
      subheading: "Streamlining Operations",
      text: "The Production Module optimizes your manufacturing and project management processes. Track projects from inception to completion, manage tasks and assignments, and ensure quality control at every step. With features for resource management, equipment tracking, and materials planning, you can maximize efficiency and minimize waste. The AI insights provide valuable recommendations for process improvements, while detailed reports help you monitor performance and make data-driven decisions.",
    },
  },
  {
    id: 7,
    imageSrc: "transparent",
    title: "Sales Module",
    type: "External Page",
    categories: ["sales"],
    description: {
      heading: "Sales Module",
      subheading: "Revenue Growth Engine",
      text: "Accelerate your sales cycle and boost revenue with our Sales Module. This powerful tool helps you manage leads, track opportunities, and close deals more efficiently. Monitor sales performance, analyze trends, and forecast future revenue with intuitive dashboards and reports. The customer relationship management features enable you to build stronger connections with clients, while the integration with other modules ensures seamless order processing and financial tracking.",
    },
  },
  {
    id: 8,
    imageSrc: "transparent",
    title: "Quality Control",
    type: "Lightbox",
    categories: ["production"],
    description: {
      heading: "Quality Control Module",
      subheading: "Excellence in Every Detail",
      text: "Ensure consistent quality across all your products and services with our Quality Control Module. Create and manage comprehensive checklists, document inspection results, and track quality metrics over time. The photo evidence feature allows you to visually document quality issues and resolutions, while the integration with the Production Module ensures that quality control is embedded in your manufacturing process. With detailed analytics and reporting, you can identify trends and continuously improve your quality standards.",
    },
  },
  {
    id: 9,
    imageSrc: "transparent",
    title: "Communication Module",
    type: "External Page",
    categories: ["communication", "management"],
    description: {
      heading: "Communication Module",
      subheading: "Seamless Connectivity",
      text: "The Communication Module enhances collaboration and information sharing across your organization. Manage emails, chat messages, and customer inquiries from a centralized dashboard. Create and manage custom API endpoints to integrate with external systems and services. With real-time notifications and message tracking, you can ensure that important communications are never missed. The module's intuitive interface makes it easy to stay connected with team members, partners, and customers.",
    },
  },
  {
    id: 10,
    imageSrc: "transparent",
    title: "Companies Module",
    type: "External Page",
    categories: ["companies", "management"],
    description: {
      heading: "Companies Module",
      subheading: "Partner Relationship Management",
      text: "The Companies Module helps you manage relationships with clients, suppliers, and other business partners. Track company details, monitor interactions, and assess risks with comprehensive tools for partner relationship management. The workforce needs assessment feature helps you plan resource allocation, while the compliance tracking ensures that all partnerships meet regulatory requirements. With detailed analytics and reporting, you can optimize your business relationships and drive mutual growth.",
    },
  },
  {
    id: 11,
    imageSrc: "transparent",
    title: "All Modules",
    type: "External Page",
    categories: ["all"],
    description: {
      heading: "Business Comanager",
      subheading: "The Ultimate Business Management System",
      text: "Business Comanager is our next-generation business management system that combines AI-driven automation with modular flexibility. It features a smart core that manages your business rules, policies, and strategies, while the AI assistant handles tasks on command, monitoring compliance and performance. Choose from essential modules including accounting, HR, recruiting, production, and quality control - all designed to grow with your business needs. Experience the future of business management, where complexity meets simplicity.",
    },
  },
];
